import { decodeVacancyStateStatus } from '@/models/VacancyState';
import { ServerApi } from '@/modules/api/server-api';

export const fetchResumeStatus = (api: ServerApi) => async (resumeId: string, vacancyId: number) => {
  const response = await api.get(`/v3/match/${resumeId}/${vacancyId}`);
  return decodeVacancyStateStatus(response.data.status);
};
